import { render, staticRenderFns } from "./recapitulation.vue?vue&type=template&id=7872c74c&"
import script from "./recapitulation.vue?vue&type=script&lang=js&"
export * from "./recapitulation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports